module.exports = __webpack_public_path__ + "img/result3.0132c38c.png";